"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tabs = function Tabs(_ref) {
  var _navigationList$curre, _navigationList$curre2, _navigationList$curre3, _navigationList$curre4;

  var defaultActive = _ref.defaultActive,
      onSelect = _ref.onSelect,
      className = _ref.className,
      children = _ref.children,
      activeTab = _ref.activeTab,
      rest = _objectWithoutProperties(_ref, ["defaultActive", "onSelect", "className", "children", "activeTab"]);

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var navigationList = (0, _react.useRef)(null);
  var currentActiveClientRect = navigationList === null || navigationList === void 0 ? void 0 : (_navigationList$curre = navigationList.current) === null || _navigationList$curre === void 0 ? void 0 : (_navigationList$curre2 = _navigationList$curre.children) === null || _navigationList$curre2 === void 0 ? void 0 : (_navigationList$curre3 = _navigationList$curre2.namedItem(active)) === null || _navigationList$curre3 === void 0 ? void 0 : _navigationList$curre3.getBoundingClientRect();
  var currentActiveClientRectParent = navigationList === null || navigationList === void 0 ? void 0 : (_navigationList$curre4 = navigationList.current) === null || _navigationList$curre4 === void 0 ? void 0 : _navigationList$curre4.getBoundingClientRect();
  (0, _react.useEffect)(function () {
    setDefaultTabActive();
  }, [defaultActive]);

  function setDefaultTabActive() {
    var tabName;

    if (defaultActive) {
      tabName = defaultActive;
    } else {
      var _Children$toArray = _react.Children.toArray(children),
          _Children$toArray2 = _slicedToArray(_Children$toArray, 1),
          firstChild = _Children$toArray2[0];

      var props = firstChild.props;
      tabName = props === null || props === void 0 ? void 0 : props.name;
    }

    setActive(tabName);
  }

  (0, _react.useEffect)(function () {
    if (active && !activeTab) {
      onSelect(active);
    }
  }, [active]);
  (0, _react.useEffect)(function () {
    if (activeTab) {
      setActive(activeTab);
    }
  }, [activeTab]);

  var handleTabClick = function handleTabClick(tabName) {
    if (activeTab) {
      onSelect(tabName);
    } else {
      setActive(tabName);
    }
  };

  return /*#__PURE__*/_react.default.createElement(TabContainer, _extends({
    className: className
  }, rest), /*#__PURE__*/_react.default.createElement(SelectorContainer, null, /*#__PURE__*/_react.default.createElement(LinkList, {
    ref: navigationList
  }, _react.Children.toArray(children).map(function (child) {
    var props = child.props;
    return /*#__PURE__*/(0, _react.cloneElement)(child, {
      active: props.name === active,
      onClick: function onClick() {
        return handleTabClick(props.name);
      }
    });
  })), /*#__PURE__*/_react.default.createElement(Selector, {
    left: (currentActiveClientRect === null || currentActiveClientRect === void 0 ? void 0 : currentActiveClientRect.left) - (currentActiveClientRectParent === null || currentActiveClientRectParent === void 0 ? void 0 : currentActiveClientRectParent.left) || 1,
    width: (currentActiveClientRect === null || currentActiveClientRect === void 0 ? void 0 : currentActiveClientRect.width) + 2 || 0
  }), /*#__PURE__*/_react.default.createElement(DividerLine, null)));
};

Tabs.defaultProps = {
  defaultActive: undefined,
  onSelect: function onSelect() {}
};
Tabs.propTypes = {
  /** only for Tabs.Item */
  name: _propTypes.string,

  /** Dont set on Tabs.Item this is only for internal usage */
  active: _propTypes.bool,

  /** Dont set on Tabs.Item this is only for internal usage */
  onClick: _propTypes.func,
  defaultActive: _propTypes.string,
  children: _propTypes.node,
  onSelect: _propTypes.func,
  className: _propTypes.string,
  activeTab: _propTypes.string
};

var Tab = function Tab(_ref2) {
  var name = _ref2.name,
      rightAlign = _ref2.rightAlign,
      children = _ref2.children,
      active = _ref2.active,
      onClick = _ref2.onClick,
      width = _ref2.width,
      rest = _objectWithoutProperties(_ref2, ["name", "rightAlign", "children", "active", "onClick", "width"]);

  return /*#__PURE__*/_react.default.createElement(Item, _extends({
    onClick: onClick,
    name: name,
    rightAlign: rightAlign,
    active: active,
    width: width
  }, rest), typeof children === 'string' || typeof children === 'number' ? /*#__PURE__*/_react.default.createElement("p", null, children) : children);
};

Tab.defaultProps = {
  rightAlign: false,
  active: false,
  onClick: function onClick() {},
  width: '12rem'
};
Tab.propTypes = {
  width: _propTypes.string,
  name: _propTypes.string.isRequired,
  rightAlign: _propTypes.bool,
  children: _propTypes.node.isRequired,
  active: _propTypes.bool,
  onClick: _propTypes.func
};

var Item = _styledComponents.default.li.withConfig({
  displayName: "Item"
})(["color:", ";cursor:pointer;font-size:1.6rem;text-align:center;padding:2rem 0;width:", ";margin-left:", ";border-bottom:2px solid rgba(0,0,0,0);text-transform:capitalize;&:hover{color:black;}"], function (props) {
  return props.active ? 'black' : '#8990a3';
}, function (props) {
  return props.width;
}, function (props) {
  return props.rightAlign ? 'auto' : 'inherit';
});

var LinkList = _styledComponents.default.ul.withConfig({
  displayName: "LinkList"
})(["display:flex;"]);

var Selector = _styledComponents.default.div.withConfig({
  displayName: "Selector"
})(["position:absolute;height:2px;background-color:", ";left:", ";width:", ";transition:0.3s ease-out;margin-top:-2px;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.brand.primary;
}, function (props) {
  return props.left ? "".concat(props.left, "px") : 'inherit';
}, function (props) {
  return props.width ? "".concat(props.width, "px") : 'inherit';
});

var SelectorContainer = _styledComponents.default.div.withConfig({
  displayName: "SelectorContainer"
})(["margin-top:1rem;margin-bottom:1rem;position:relative;"]);

var DividerLine = _styledComponents.default.div.withConfig({
  displayName: "DividerLine"
})(["width:100%;height:1px;background-color:#e4e4e4;z-index:-9;margin-top:-2px;"]);

var TabContainer = _styledComponents.default.nav.withConfig({
  displayName: "TabContainer"
})(["width:100%;font-family:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.font;
});

Tabs.Item = Tab;
Tabs.Item.displayName = 'Tabs.Item';
var _default = Tabs;
exports.default = _default;